import { render, staticRenderFns } from "./LoversCustom.vue?vue&type=template&id=ae39c488&scoped=true"
import script from "./LoversCustom.vue?vue&type=script&lang=js"
export * from "./LoversCustom.vue?vue&type=script&lang=js"
import style0 from "./LoversCustom.vue?vue&type=style&index=0&id=ae39c488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae39c488",
  null
  
)

export default component.exports